import { FC, PropsWithChildren } from "react";
import { TabPanelProps, useTabContext } from "@mui/lab";
import { Box } from "@mui/material";

interface UnmountTabPanelProps extends TabPanelProps {
  noPadding?: boolean;
}

export const UnmountTabPanel: FC<PropsWithChildren<UnmountTabPanelProps>> = ({
  children,
  value,
  noPadding,
  ...props
}) => {
  const { value: contextValue } = useTabContext() || {};

  const styles = {
    paddingTop: "24px !important",
    paddingBottom: noPadding ? "0 !important" : "16px !important",
    paddingLeft: noPadding ? "0 !important" : "16px !important",
    paddingRight: noPadding ? "0 !important" : "16px !important",
  };

  return (
    <Box
      sx={{
        display: value === contextValue ? "block" : "none",
        ...props.sx,
        ...styles,
      }}
      key={value}
    >
      {children}
    </Box>
  );
};
